import request from "./request";

const normalizeOrder = (raw: any = {}) => ({
  ...raw,
  uuid: raw.uuid,
  orderNo: raw.orderNo,
  cartSnapshot: {
    items: raw.cartSnapshot?.items ?? [],
  },
  totals: raw.totals ?? {},
  deliveryInfo: raw.deliveryInfo ?? {},
});

const orderId = (order?: { uuid?: string }) => order?.uuid;

const checkout = async (data: any, { receipt, idempotencyKey }: any = {}) => {
  const headers: Record<string, string> = {};
  if (idempotencyKey) headers["Idempotency-Key"] = idempotencyKey;

  let body = data;
  if (receipt) {
    const formData = new FormData();
    Object.entries(data || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (typeof value === "object") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, String(value));
      }
    });
    formData.append("receiptImage", receipt);
    body = formData;
  }

  const res = await request({
    url: "/v1/public/orders",
    method: "post",
    data: body,
    headers,
  });
  return res.data;
};

const order = async (id: string) => {
  const { data } = await request({ url: `/v1/orders/${id}` });
  return normalizeOrder(data);
};

const orders = async (params?: any) => {
  const { data } = await request({ url: `/v1/orders`, params });
  const list = data?.orders ?? [];
  return {
    ...data,
    orders: Array.isArray(list) ? list.map(normalizeOrder) : [],
  };
};

export default { checkout, order, orders, orderId };
